import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import { FC, useEffect, useRef, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import SearchCommittees from '../../component/web/committees/SearchCommittees'
import SearchCommitteesResults from '../../component/web/committees/SearchCommitteesResult'
import useCommittees from '../../component/web/shareLogic/useCommittees'
import SearchAccordion from '../../control/accordion/SearchAccordion'
import useLoading from '../../control/loading/useLoading'
import useTranslate from '../../i18n/useTranslate'

const ManageCommittees: FC<{}> = () => {
    const initialFormValues = {
        keyword: '',
        startDate: moment().subtract('years', 1).format('yyyy-MM-DD'),
        endDate: moment().format('yyyy-MM-DD'),
        rec: null,
        faculty: null,
        expertise: null,
        currentStartDate: moment().subtract('years', 1).format('yyyy-MM-DD'),
        currentEndDate: moment().format('yyyy-MM-DD'),
    }
    const [searchResult, setSearchResult] = useState<any[]>([])
    const translate = useTranslate()
    const committeesHook = useCommittees()
    const loadingHook = useLoading()
    const formRef = useRef<any>()

    const submitSearch = async (values: Record<string, any>) => {
        loadingHook.loadingOpen()
        const response = await handleSearch(values)
        loadingHook.loadingClose()
        setSearchResult(response.result ?? [])
    }

    const handleSearch = (values: Record<string, any>) => {
        formRef.current.change('currentStartDate', values.startDate)
        formRef.current.change('currentEndDate', values.endDate)
        return committeesHook.searchCommittees(
            values.keyword && values.keyword !== '' ? values.keyword : null,
            values.faculty ? Number(values.faculty.value) : null,
            values.expertise ? Number(values.expertise.value) : null,
            values.startDate,
            values.endDate,
        )
    }

    useEffect(() => {
        loadingHook.loadingOpen()
        committeesHook
            .searchCommittees(
                null,
                null,
                null,
                moment().subtract('years', 1).format('yyyy-MM-DD'),
                moment().format('yyyy-MM-DD').toString(),
            )
            .then((data) => {
                setSearchResult(data.result)
            })
            .finally(() => {
                loadingHook.loadingClose()
            })
    }, [])

    return (
        <Container maxWidth="lg">
            <FinalForm onSubmit={submitSearch} initialValues={initialFormValues}>
                {({ form }) => {
                    formRef.current = form
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SearchAccordion title={translate.get('LABEL.COMMITTEE_NAME')}>
                                    <SearchCommittees />
                                </SearchAccordion>
                            </Grid>
                            <Grid item xs={12}>
                                <SearchCommitteesResults searchResult={searchResult} />
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Container>
    )
}

export default ManageCommittees
